export const FILTER_FETCH_ALERT_TYPE = 'FILTER_FETCH_ALERT_TYPE';
export const FILTER_SET_ALERT_TYPE_FILTER = 'FILTER_SET_ALERT_TYPE_FILTER';
export const FILTER_SET_KEYWORD_FILTER = 'FILTER_SET_KEYWORD_FILTER';
export const FILTER_SET_GROUP_FILTER = 'FILTER_SET_GROUP_FILTER';
export const FILTER_SET_GROUPDISPONIBILIDAD_FILTER = 'FILTER_SET_GROUPDISPONIBILIDAD_FILTER';
export const FILTER_SET_BRANDS_FILTER = 'FILTER_SET_BRANDS_FILTER';
export const FILTER_SET_ALERT_TYPES = 'FILTER_SET_ALERT_TYPES';
